export const Loyaltic = {
    API: {
        CaptureEmail: 'api/v1/capturereminderemail',
        Notifyuser: 'api/v1/notifyuser',
        LiveConfig: 'api/v1/liveconfig',
        Login: 'api/v1/login',
        Upload: 'api/v1/user/upload',
        AvailableGames: 'api/v1/user/availablegames',
        pay : 'api/v1/swishpay',
        LoginWithUploadReceipt: 'api/v1/user/regwithupload',
        Play: 'api/v1/play',
        RegistrationTrends: 'api/v1/analytics/registrations',
        ReceiptTrends: 'api/v1/analytics/receipts',
        RewardTrends: 'api/v1/analytics/rewards',
        ProductTrends: 'api/v1/analytics/products',
        RewardSizeDistribution: 'api/v1/analytics/reward-sizes',
        RewardNotificationOptIns: 'api/v1/analytics/reward-notifications',
        ReportChartConfig: 'api/v1/analytics/chartconfig',
        ReceiptsQuery: 'api/v1/reports/receipts/query',
        ReceiptsTableConfig: 'api/v1/reports/receipts/tableconfig',
        ReceiptsInvestigate: 'api/v1/reports/receipts/investigate',
        FetchTotal: 'api/v1/fetchtotal',
        FbSharePoints: 'api/v1/user/fbsharebonuspoints',
        TestWin: 'api/v1/testwin',
        CaptureAddress: 'api/v1/captureaddress',
        CaptureDigitalWin: 'api/v1/capturedigitalwin',
        StripePay: 'api/v1/stripepay',
        Emailreminder: 'api/v1/capturereminderemail',
        RegUploadWithRealTimeScanning: 'api/v1/user/regwithrealtimescanningandupload',
        Participate: 'api/v1/participate',
        UploadWithRealTimeScanning: 'api/v1/user/uploadwithrealtimescanning',
        confirmuploadafterscanning: 'api/v1/upload/confirmupload',
        LocalizationByCulture: 'api/v1/LocalizationByCulture',
        LocalizationByPage: 'api/v1/LocalizationByPage',
        SendFeedback: 'api/v1/sendfeedback',
        Register: 'api/v1/register',
        ForgotPassword: 'api/v1/forgotpassword',
        ResetPassword: 'api/v1/resetpassword',
        LatestAddress: 'api/v1/user/latestaddress',
        OrderReward: 'api/v1/user/orderreward',
        Points: 'api/v1/user/points',
        Rewards: 'api/v1/rewards',
        profile: 'api/v1/profile',
        products: 'api/v1/products',
        Localization: {
            Controller: 'Admin/',
            Actions: {
                LocalizationByPage: 'LocalizationByPage',
                AddNewGlobalLocalization: 'AddNewGlobalLocalization',
                UpdateGlobalLocalization: 'UpdateGlobalLocalization',
                LocalizationByCulture: 'LocalizationByCulture',
            }
        }
    },
    WithOutReceiptRedirectUrl: '#'
};
